import { render } from "./ButtonApp.vue?vue&type=template&id=4d4cdba8"
import script from "./ButtonApp.vue?vue&type=script&lang=js"
export * from "./ButtonApp.vue?vue&type=script&lang=js"

import "./ButtonApp.vue?vue&type=style&index=0&id=4d4cdba8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__